module.exports = __webpack_public_path__ + "public/img/success.476f5306.png";